import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { ToastProvider } from './ToastContext';

// Base 14.4px = réduction 10 % des tailles (1rem)
if (typeof document !== 'undefined') {
  document.documentElement.style.setProperty('font-size', '14.4px', 'important');
  document.documentElement.style.setProperty('-webkit-text-size-adjust', '100%');
  document.documentElement.style.setProperty('text-size-adjust', '100%');
}

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <ToastProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ToastProvider>
  </React.StrictMode>
);
